import axios from "axios";

// export const imgUrl = 'http://localhost:4000';
// const API_BASE_URL = 'http://localhost:4000/api/v1.0';

export const imgUrl = 'https://alliraa-ecommerce.onrender.com';
const API_BASE_URL = 'https://alliraa-ecommerce.onrender.com/api/v1.0';
const apiAlira = axios.create({
    baseURL: API_BASE_URL,
});

apiAlira.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        if (config.data instanceof FormData) {
            config.headers["Content-Type"] = "multipart/form-data";
        } else {
            config.headers["Content-Type"] = "application/json";
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Function for making GET requests 
export const getData = async (endpoint) => {
    try {
        const response = await apiAlira.get(endpoint);
        return response.data;
    } catch (error) {
        console.error("GET Error:", error);
        throw error;
    }
};

// Function for making POST requests
export const postData = async (endpoint, data) => {
    try {
        const response = await apiAlira.post(endpoint, data);
        // console.log("api",response )
        return response.data;
    } catch (error) {
        console.error("POST Error:", error);
        throw error;
    }
};

// Function for making PUT requests
export const putData = async (endpoint, data) => {
    try {
        const response = await apiAlira.put(endpoint, data);
        return response.data;
    } catch (error) {
        console.error("PUT Error:", error);
        throw error;
    }
};

// Function for making PATCH requests
export const patchData = async (endpoint, data) => {
    try {
        const response = await apiAlira.patch(endpoint, data);
        return response.data;
    } catch (error) {
        console.error("PATCH Error:", error);
        throw error;
    }
};

// Function for making DELETE requests (with body support)
export const deleteData = async (endpoint, data = {}) => {
    try {
        const response = await apiAlira.delete(endpoint, {
            data: data
        });
        return response.data;
    } catch (error) {
        console.error("DELETE Error:", error);
        throw error;
    }
};




